export const fllUw = {

	profileTop: {
		withIso: 0.14,
		noIso: 0.074
	},
	louvreShock: {
		withIso: 0.14,
		noIso: 0.08
	},
	profileBottom: {
		withIso: 0.18,
		noIso: 0.11
	},
	profileSide: {
		withIso: 0.15,
		noIso: 0.059
	},
	middleMullion: {
		withIso: 0.25,
		noIso: 0.098
	},

};